import { AppServices, registerAppServices } from 'conversations/services'
import { noop } from 'rxjs'
import config from 'shared/config'
import { isDev } from 'shared/utils/environment'

import { redirectToLoginPage as webAuthRedirect } from '@driftt/web-auth'

const webAppServices: AppServices = {
  notifications: {
    sendNotification: () => {
      // 'No op for showing notification in WebApp. This is done by Traffic Control
      return Promise.resolve()
    },
  },
  badges: {
    showBadgeIconNumber: () => Promise.resolve(),
    isWindowVisible: () => new Promise((resolve) => resolve(document.hasFocus())),
  },
  auth: {
    openWebLogin: () => webAuthRedirect(config.CLIENT_ID),
    logout: async () => {
      window.history.pushState({}, '', '/')
      webAuthRedirect(config.CLIENT_ID)
    },
  },
  util: {
    // eslint-disable-next-line
    log: (entry: any) => {
      if (isDev) {
        // eslint-disable-next-line no-console
        console.log(entry.message)
      }
    },
  },
  reload: {
    reloadApplication: () => window.location.reload(),
  },
  redux: {
    sendAction: noop,
  },
}

export const registerWebAppServices = () => {
  registerAppServices(webAppServices)
}
